export type Variants<T> = T | (string & {});
